import React, { ReactElement, CSSProperties, SVGProps, useMemo } from 'react';

type FloatingShapeProps = {
  i: number;
  animationOffset: number;
  svg: ReactElement<SVGProps<SVGSVGElement>>;
};

const FloatingShape: React.FC<FloatingShapeProps> = ({ i, animationOffset, svg }) => {
  const { left, top, angle } = useMemo(
    () => ({
      left: `${Math.random() * 90}%`,
      top: `${Math.random() * 90}%`,
      angle: Math.random() * 360,
    }),
    []
  );

  const amplitude = 100;
  const x = Math.cos(((animationOffset + i * 10) * Math.PI) / 180 + angle) * amplitude;
  const y = Math.sin(((animationOffset + i * 10) * Math.PI) / 180 + angle) * amplitude;

  return React.cloneElement(svg, {
    className: 'absolute opacity-30',
    style: {
      left,
      top,
      transform: `translate(${x}px, ${y}px)`,
      transition: 'transform 1s ease-in-out',
      position: 'absolute',
    } satisfies CSSProperties,
  });
};

export default FloatingShape;
